import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useAddInventoryObject = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.post(`/inventory/objects`, data)
    },
  })

  const save = async (data: any) => {
    try {
      return await mutation.mutateAsync(data)
    } catch (error: any) {
      const message =
        error?.response?.data?.data?.msg ||
        error?.response?.data?.error ||
        'request.unknown_error'
      addError(trs(message))
    }
  }

  return {
    ...mutation,

    save,
  }
}
